export default class DtoPreparedRequest {
    constructor(obj) {
        this.id = obj.id
        this.name = obj.name
        this.description = obj.description
        this.request = obj.request
    }
}